<template>
  <v-container id="invoices-table">
    <MaterialCard elevation="0" color="primary" :title="$t('title.invoices')">
      <base-datatable
        ref="invoicesDatatable"
        :header_items="headers"
        :type="$t('title.invoices')"
        dispatch_get="invoice/invoices"
        id_field="uuid"
      >
        <template v-slot:item.download="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn
                v-on="on"
                text
                icon
                :loading="downloading_uuid === item.uuid"
                :disabled="downloading_uuid !== null"
                @click="download_invoice(item)"
              >
                <v-icon>mdi-download</v-icon>
              </v-btn>
            </template>
            <span>{{ $t("button.download_invoice") }}</span>
          </v-tooltip>
        </template>
      </base-datatable>
    </MaterialCard>
  </v-container>
</template>

<script>
import MaterialCard from "@/components/views/MaterialCard";
import BaseDatatable from "@/components/views/BaseDatatable";
import { invoice_table } from "@/mixins/invoice";

export default {
  name: "Invoices",
  components: { BaseDatatable, MaterialCard },
  mixins: [invoice_table],
  data() {
    return {
      downloading_uuid: null
    };
  },
  methods: {
    download_invoice(item) {
      this.downloading_uuid = item.uuid;
      this.$store
        .dispatch("invoice/downloadInvoice", { invoice_uuid: item.uuid })
        .then(response => {
          const file_url = window.URL.createObjectURL(
            new Blob([response.data], { type: "application/pdf" })
          );
          const link = document.createElement("a");
          link.href = file_url;
          link.setAttribute("download", `invoice-${item.invoice_number}.pdf`);
          document.body.appendChild(link);
          link.click();
          link.remove();
          window.URL.revokeObjectURL(file_url);
        })
        .finally(() => {
          this.downloading_uuid = null;
        });
    }
  }
};
</script>
